import { io } from "socket.io-client";
import { serverPath } from "./keys.js";

const token = localStorage.getItem("ad@#t")
  ? localStorage.getItem("ad@#t")
  : null;
const adminRoomId = "sdjhnhjG^T$%^RTGEYUD^#$%I@#O$*YERHUFB";

const socket = io(serverPath, {
  reconnectionDelayMax: 1000,
  reconnection: true,
  transports: ["websocket", "xhr-polling"],
  rejectUnauthorized: false,
  query: `token=${token}`,
});

socket.on("connect", () => {
  socket.emit("join", { userId: adminRoomId });
  socket.emit("adminJoin", adminRoomId);
});

const tryReconnect = () => {
  setTimeout(() => {
    socket.io.open((err) => {
      if (err) {
        tryReconnect();
      }
    });
  }, 2000);
};

socket.io.on("close", tryReconnect);

export { socket };
